<script>
import Input from '@zoom/zoom-ui/src/components/input/input.vue';

export default {
  extends: Input,
  methods: {
    handleInput(event) {
      // should not emit input during composition
      // see: https://github.com/ElemeFE/element/issues/10516
      if (this.isComposing) return;

      // hack for https://github.com/ElemeFE/element/issues/8548
      // should remove the following line when we don't support IE
      if (event.target.value === this.nativeInputValue) return;

      // NEW: support old value
      this.$emit('input', event.target.value, this.value);

      // ensure native input value is controlled
      // see: https://github.com/ElemeFE/element/issues/12850
      this.$nextTick(this.setNativeInputValue);
    },
  }
};
</script>
